import Swiper, {Navigation} from 'swiper';

const careerSliders = Array.from(document.querySelectorAll('.j-career-default-slider'));

careerSliders.forEach((careerSlider) => {
    let slider = {};
    const sliderContent = careerSlider.querySelector('.j-career-slider');
    const options = {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 30,
        navigation       : {
            nextEl: careerSlider.querySelector('.j-career-next'),
            prevEl: careerSlider.querySelector('.j-career-prev')
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    slider = new Swiper(sliderContent, options);

    slider.init();
});

